export const hongbao = {
    hb: "Phong bì đỏ",
    dps: "Phát hàng loạt",
    xdhb: "Phong bì đỏ giới hạn, hàng ngàn ưu đãi đang chờ bạn",
    fxhb: "Chia sẻ phong bì đỏ để nhận thêm phần thưởng",
    khb: "Mở phong bì đỏ",
    kqz: "Đang mở...",
    ylq: "Đã nhận",
    hdwks: "Sự kiện chưa bắt đầu",
    hdjxz: "Sự kiện đang diễn ra",
    hdyjs: "Sự kiện đã kết thúc",
    hddjs: "Đếm ngược sự kiện",
    hdsj: "Thời gian sự kiện",
    zwhd: "Chưa có sự kiện",
    hblsjlxq: "Lịch sử phần thưởng phong bì đỏ của tôi",
    jxz: "Đang diễn ra",
    ygq: "Đã hết hạn",
    dks: "Sắp bắt đầu",
    zwjl: "Chưa có phần thưởng",
    wnmztj: "Bạn chưa đáp ứng điều kiện sự kiện",
    wxts: "Lưu ý",
    yhwcrz: "Người dùng đã hoàn thành xác thực KYC và liên kết số điện thoại",
    yhwcjy: "Người dùng hoàn thành một trong các điều kiện: giao dịch giao ngay ≥100 USDT HOẶC giao dịch hợp đồng (không bao gồm đòn bẩy) ≥100 USDT HOẶC giao dịch quyền chọn ≥100 USDT HOẶC giao dịch GameFi ≥100 USDT",
    djzh: "Tài khoản bị kiểm soát rủi ro hoặc bị hạn chế rút tiền không thể tham gia sự kiện.",
    hdhbjl: "Nhận thưởng",
    sqbj: "Vận may chưa tốt",
    dkapp: "Mở ứng dụng",
    smewm: "Quét mã QR",
    wchdtj: "Hoàn thành điều kiện sự kiện để nhận phong bì đỏ",
    fxhd: "Chia sẻ sự kiện để nhận thêm phong bì đỏ",
    jdcz: "Thao tác đơn giản, kiếm thu nhập",
    hdhb: "Phong bì đỏ sự kiện",
    zdqj: "Kỳ hạn chỉ định",
    wcjye: "Hoàn thành khối lượng giao dịch {type} {text} ≥ {amount} USDT",
    yhwfhtj: "Trong vòng {time} trước khi phong bì đỏ ra mắt, người dùng không có giao dịch đủ điều kiện",
    hbsxq: "Trong vòng {time}{day} trước khi phong bì đỏ ra mắt, người dùng {text}",
    bhgg: "Không bao gồm đòn bẩy",
    "h": " hoặc ",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/hongbao/vi.js